module.exports = __webpack_public_path__ + "static/32b3e375-941e-4c75-adab-065c25caa875-500.9a9370ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/sir-hugh-holy-trinity-northwood/32b3e375-941e-4c75-adab-065c25caa875-500.jpg
// module id = 1076
// module chunks = 168707334958949